
import attributsService from "../../../services/attribut.service";
// import { SET_MESSAGE } from "../message/type";
import {
  ATTRIBUTS_BY_PERIMETRE_SUCCESS,
  ATTRIBUTS_BY_PERIMETRE_FAIL,
  ATTRIBUTS_GRILLE_FAIL ,
LIST_ATTRIBUTS_GRILLE_SUCCESS ,
} from "./type";

export const getAttributsBYPerimetre = (data) => (dispatch) => {
    return attributsService.attributsByPerimetre(data).then(
      (response) => {
        dispatch({
          type: ATTRIBUTS_BY_PERIMETRE_SUCCESS,
          payload: response.data,
        });
  
        // dispatch({
        //   type: SET_MESSAGE,
        //   payload: {
        //     message: response.message,
        //     status: response.status,
        //   },
        // });
  
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
  
        dispatch({
          type: ATTRIBUTS_BY_PERIMETRE_FAIL,
        });
  
        // dispatch({
        //   type: SET_MESSAGE,
        //   payload: {
        //     message: message,
        //     status: error.status,
        //   },
        // });
  
        return Promise.reject();
      }
    );
  };

export const getAttributsGrid = (gridId) => (dispatch) =>{
    return attributsService.getAttributsByGrid(gridId).then(
      (response) => {
        dispatch({
          type: LIST_ATTRIBUTS_GRILLE_SUCCESS,
          payload: response.data,
        });
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
  
        dispatch({
          type: ATTRIBUTS_GRILLE_FAIL,
        });
        return Promise.reject();
  
      }
   
    )
  }